export default __webpack_public_path__ + "static/media/congrats.1f2d8f33.svg";